import gsap from 'gsap'

import ee from '../ee'

function loadMoreItems(selector, limit, target) {
  let items = Array.from(document.querySelectorAll(selector))
  let hiddenItems = items.filter((item) => item.classList.contains('hidden'))
  let itemsToLoad = hiddenItems.slice(0, limit)

  itemsToLoad.forEach((item) => item.classList.remove('hidden'))

  gsap.from(itemsToLoad, {
    autoAlpha: 0,
    y: 20,
    duration: 0.5,
    stagger: 0.1,
  })

  let hasRemainingItems = hiddenItems.length - limit > 0

  if (!hasRemainingItems) {
    target.parentElement.classList.add('hidden')
  }
}

function loadMoreNews({ target }) {
  loadMoreItems('.js-news', 4, target)
}

function loadMoreProjects({ target }) {
  loadMoreItems('.js-project', 2, target)
}

function init() {
  if (!location.pathname.includes('search-results')) {
    return
  }

  let el_moreProjectsButton = document.querySelector('.js-more-projects-button')
  let el_moreNewsButton = document.querySelector('.js-more-news-button')

  el_moreNewsButton?.addEventListener('click', loadMoreNews)
  el_moreProjectsButton?.addEventListener('click', loadMoreProjects)
}

ee.addListener('initComponents', init)
